import {getUrlParameter} from "../utils";
import Vue from "vue";
import Vuex from "vuex";

import categories from "./modules/categories";
import search from "./modules/search";
import scale from "./modules/scale";
import screen from "./modules/screen";
import toast from "./modules/toast";
import inlineDrawers from './modules/inlineDrawers';
import landingPage from "./modules/landingPage";
import config from "./modules/config";
import shoppingList from "../features/shopping-list/store/shoppingList";
import deepLinking from "@/store/modules/deepLinking";
import Lytics from "@/classes/Lytics";
import filters from "../features/filters/store/filters";
import en from "@/lang/en.json";
import fr from "@/lang/fr.json";
import {merge} from "lodash";
import router from "@/router";
import pdp from "@/features/pdp/store/pdp";
import Service from "@/api/Service";
import Rest from "@/api/Rest";
import header from "@/store/modules/header";
import drawer from "@/store/modules/drawer";
import ctUser from "@/features/triangle-rewards/store/ctUser";
import ctOffersUser from "@/features/offers/store/ctOffersUser";
import events from "@/store/modules/events";
import raddar from "@/features/raddar/store/raddar";
import storeLocator from "@/features/store-locator/store/store-locator";
import AppConfig from "@/classes/AppConfig";
import {getProductSku} from "@/features/shopping-list/classes/ShoppingListController";
import wishListStore from "@/features/wishlist/store/wishListStore";
import Page from "@/classes/Page";
import moment from "moment";
import product from "@/store/modules/product";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		loading: 0,
		pageData: null,
		pages: [],
		totalPages: 0,
		columnView: false,
		/*highlightResults: false,*/
		language: "en",
		currentStore: null,
    currentStoreObj: {
      storeName: '',
      address: '',
      city: '',
      province: ''
    },
		currentPageNumber: 1,
		currentPageIndex: 0,
		zonesArray: null,
		pdf: null,
		apiUrl: process.env.VUE_APP_API_URL,
		subscriptionKey: process.env.VUE_APP_API_KEY,
		banner: process.env.VUE_APP_BANNER,
		searchInputFocused: false,
		showPdp: false,
		showHamburgerMenu: false,
		showSideBar: false,
		currentProduct: null,
		currentVideo: null,
		xRayMode: false,
		xRayData: {
			block: {
				raw: null,
				rendered: null
			},
			page: {
				raw: null,
				rendered: null
			},
			flyer: {
				raw: null,
				rendered: null
			},
			product: null
		},
		pageRenderedData: null,
		flyerRenderedData: null,
		productRenderedData: null,
		imageRenderedData: null,
		showFilters: false,
		blockData: {},
		pageInjections: [],
		istiledView:false,
	},

	getters: {
		language() {
			return router.currentRoute.query.language || 'en';
		},
			TiledView: state => state.istiledView,
		storeId() {
			return parseInt(router.currentRoute.query.storeId || '', 10);
		},
		aud() {
			return router.currentRoute.query.aud || null;
		},
		dealId(state, getters, rootState, rootGetters) {
			return rootGetters["landingPage/currentFlyer"]?.title;
		},
		filterableItems(state) {
			return state.pages.map((page) => page.blocks).flat();
		},
		isPreviewFlyer(state, getters, rootState, rootGetters) {
			return rootGetters["landingPage/currentFlyer"]?.flyerType === 'preview';
		},
		/**
		 * Retrieves the current date, either from the `timeTravelDate` query parameter or defaults to the current system date converted to utc.
		 * If the `timeTravelDate` query parameter is invalid or not provided, the method returns the current date (UTC).
		 *
		 * @return {moment.Moment} A moment object representing either the parsed `timeTravelDate` or the current date (UTC).
		 */
		currentDate(state, getters) {
			if(getters.isPreviewFlyer)	{
				return moment.utc(getters.currentFlyer.startDate, 'YYYY-MM-DD').startOf('day');// this.validFromFlyer;
			}
			const date = moment.utc(router.currentRoute.query['timeTravelDate']);
			if(date.isValid() && router.currentRoute.query['timeTravelDate']) return date;

			return moment().utc();
		},

		hasBaseBars(state) {
			return state.pages.some((page) => !!page.basebars)
		},

		currentBaseBars(state, getters, rootState, rootGetters) {
			const bb = [];
			const displayMode = rootGetters["screen/displayMode"];
			state.pages.forEach((page) => {
				const baseBar = page?.basebars?.[displayMode]?.[0];
				if (baseBar) {
					bb.push({...baseBar, page, displayMode});
				}
			})
			return bb;
		},

		currentFlyer(state, getters, rootState, rootGetters) {
			return rootGetters["landingPage/currentFlyer"];
		},

		maxBaseBarHeight(state, getters, rootState, rootGetters) {
			const displayMode = rootGetters["screen/displayMode"];
			let max = 0;
			getters.currentBaseBars.forEach((item) => {
				const {aspectRatio, page} = item;
				const {w} = Page.CalcPageSize(page, displayMode);

				const height = w / aspectRatio;
				//console.log("** maxBaseBarHeight:", w, aspectRatio, "  Height:", height, "  Page:", page.page_num);

				max = Math.max(max || 0, height);
			});
			return max;
		},

		currentZone(state) {
			let l = -1;
			let z = "";
			const pages = state.pages;
			pages.map((page) => {
				page.blocks.map((block) => {
					if (block.zones?.length > l) {
						l = block.zones.length;
						z = block.zones[0];
					}
				});
			});
			return z;
		},

		// eslint-disable-next-line no-unused-vars
		content(state, getters) {
			return getters.lang;
		},

		lang(state, getters, rootState, rootGetters) {
			const dict = {en, fr};
			const config = rootGetters['config/settings'];
			return merge(dict[getters.language], (config?.lang || {})[getters.language]);
		},

		highlightResults(state, getters, rootState, rootGetters) {
			const currentFlyer = rootGetters["landingPage/currentFlyer"];
			return !currentFlyer?.blockedFlyer;
		},
		isSearchInputFocused(state) {
			return state.searchInputFocused;
		},
		isCTC() {
			return AppConfig.AppConf?.title.toLowerCase().includes("canadian".toLowerCase()) ? true : false
		},
		isJC() {
			return AppConfig.AppConf?.title.toLowerCase().includes("jean".toLowerCase()) ? true : false
		},
		isRexall() {
			return AppConfig.AppConf?.title.toLowerCase().includes("rexall".toLowerCase()) ? true : false
		},
		isMetro() {
			return AppConfig.AppConf?.title.toLowerCase().includes("metro".toLowerCase()) ? true : false
		},
		blockData(state) {
			return state.blockData || {}
		},
		publicationId(state) {
			return state.pages.find((page) => {
				return !!page.publicationId;
			})?.publicationId;
		},
		productsBySKU(state, getters) {
			const o = {};
			getters.filterableItems.forEach((block) => {
				block.products.forEach((prod) => {
					const sku = getProductSku(prod);
					if(sku)o[getProductSku(prod)] = {...prod, blockData: block};
				})
			})
			return o;
		},
		findBlocksBySKUs: (state, getters) => (skus) => {
			const blocks = [];
			skus.forEach(sku => {
				// filter out URL blocks
				if (sku === 'URL') return;

				const product = getters.productsBySKU[sku];

				// filter out duplicate blocks
				if (product && !blocks.includes(product.blockData)) {
					blocks.push(product.blockData);
				}
			})
			return blocks;
		},
		isHalfPageGrid(state) {
			let result = state.pages.some(page => {
				return (page.grids?.desktop.colCount === 60)
			});
			return result
		},
		isXRayEnabled() {
			return router.currentRoute.query['x-ray'] === '1'
		},
	},

	actions: {

		setLoadingState({commit}, ls) {
			commit("UPDATE_LOADING", ls ? 1 : -1);
		},

		/**
		 * Function to inject page data into the flyer.
		 * @param commit
		 * @param payload - Injection function <func(pages, pagesIndex,unitWidth, unitHeight, language)>
		 *     pages - Array of pages
		 *     pagesIndex - page number to pages array index eg pagesIndex[<page-num>] = pages<Array Index>. These value do not always align as some pages are not counted as page numbers ie: Ads and special layouts.
		 *     unitWidth - width of a block the unit
		 *     unitHeight - height of a block the unit
		 *     language - language of the flyer
		 */
		injectPage({commit}, payload) {
			commit("ADD_PAGE_INJECTION", payload);
		},

		async setPages({commit, getters, dispatch}, payload) {
			// console.log("** setPages:", flyerId)
			commit("UPDATE_LOADING", 1);

			commit("CLEAR_PAGE_INJECTIONS");

			await dispatch('config/loadConfig');


			const storeId = getters.storeId;
			const lang = getters.language === 'fr' ? 'bil' : 'en'; //  getUrlParameter("language") === 'fr' ? 'bil' : 'en';


			try {
				//if pagesJson is not passed in the landing page call, it will fetch pages through the API as a fallback
				const data = payload.pagesUrl !== null ? await Service.GetFlyerPage(payload.pagesUrl) : await Service.GetFlyerPage(null, payload.flyerId, storeId, lang);

				commit("SET_PAGES", data);

			} catch (error) {
				await Rest.GotoErrorPage(error);
			}

			commit("UPDATE_LOADING", -1);
			//router.push({ name: 'DefaultFlyer', params: { flyerId: flyerId,...router.currentRoute.params }, query: router.currentRoute.query })
		},

		updatePages({commit}, pages) {
			commit("SET_PAGES", pages);
		},
		setTiledView({ commit }, value) {
        commit('SET_TILED_VIEW', value);
      },
		setTotalPages({commit}, value) {
			commit("SET_TOTAL_PAGES", value);
		},

		setColumnView({commit, dispatch, state, getters}, isColumnView) {
			if (state.columnView !== isColumnView) {
				commit("SET_COLUMN_VIEW", isColumnView);
				Lytics.TriggerScreenOrientationChange();
				Lytics.TriggerOrientationToggle(isColumnView ? 'vertical' : 'horizontal', getters['screen/displayMode']);
				dispatch("screen/handleWindowResize");
			}
		},

		toggleColumnView({commit, dispatch, state, getters}) {
			commit("TOGGLE_COLUMN_VIEW");
			Lytics.TriggerScreenOrientationChange();
			Lytics.TriggerOrientationToggle(
				state.columnView ? "vertical" : "horizontal",
				getters["screen/displayMode"]
			);
			dispatch("screen/handleWindowResize");
		},
		toggleTiledView({ commit, dispatch, state, getters }) {
				commit('TOGGLE_TILED_VIEW');
				Lytics.TriggerScreenOrientationChange();
				Lytics.TriggerOrientationToggle(
				state.columnView ? "vertical" : "horizontal",
				getters["screen/displayMode"]
			);
			dispatch("screen/handleWindowResize");
		},
		toggleMobileFilters({commit}) {
			commit("TOGGLE_MOBILE_FILTERS")
		},

		/* setHighlightResults({ commit }, val) {
		   commit("SET_HIGHLIGHT_RESULTS", val);
		 },*/
		setLanguage({commit}) {
			const lang = getUrlParameter("language");
			commit("SET_LANGUAGE", lang);
		},
		setCurrentStore({commit}, store) {
			commit("SET_CURRENT_STORE", parseInt(store));
		},
    setCurrentStoreObj({commit}, storeObj) {
      commit("SET_CURRENT_STORE_OBJ", storeObj);
    },
		setZonesArray({commit}, zones) {
			commit("SET_ZONES_ARRAY", zones);
		},
		setPdf({commit}, pdf) {
			commit("SET_PDF", pdf);
		},
		setSearchInputFocusState({commit}, s) {
			commit("SET_SEARCH_INPUT_FOCUSED", s);
		},
		setPdpDisplay({commit}, value) {
			commit("SET_PDP_DISPLAY", value);
		},
		setCurrentProduct({commit}, e) {
			commit("SET_CURRENT_PRODUCT", e);
		},
		setCurrentVideo({commit}, url) {
			commit("SET_CURRENT_VIDEO", url);
		},
		setBlockData({commit}, data) {
			commit("SET_BLOCK_DATA", data);
		},
		toggleHamburgerMenu({commit}, value) {
			commit("SHOW_HAMBURGER_MENU", value);
		},
		toggleSideBarState({commit}, value) {
			commit('TOGGLE_SIDEBAR', value)
		},
		reset({commit}) {
			commit("RESET")
		},
		setCurrentPageNumber({commit}, val) {
			commit("SET_CURRENT_PAGE_NUMBER", val)
		},
		setCurrentPageIndex({commit}, val) {
			commit("SET_CURRENT_PAGE_INDEX", val)
		},
		setXRayMode({commit}, val) {
			commit("SET_X_RAY_MODE", val)
		},
		setXRayData({commit}, data) {
			commit("SET_X_RAY_DATA", data)
		},
		setPageRenderedData({commit}, data) {
			commit("SET_PAGE_RENDERED_DATA", data)
		},
		setFlyerRenderedData({commit}, data) {
			commit("SET_FLYER_RENDERED_DATA", data)
		},
		setProductRenderedData({commit}, data) {
			commit("SET_PRODUCT_RENDERED_DATA", data)
		},
		setImageRenderedData({commit}, data) {
			commit("SET_IMAGE_RENDERED_DATA", data)
		},
		resetScrollContextByToggle({ commit }) {
		commit('RESET_SCROLL_CONTEXT_TOGGLE');
	},

	},
	mutations: {
		UPDATE_LOADING(state, val) {
			state.loading += val;
		},
		SET_PAGE_DATA(state, data) {
			state.pageData = data;
		},
		SET_PAGES(state, pages) {
			state.pages = pages;
		},
		SET_TOTAL_PAGES(state, value) {
			state.totalPages = value;
		},
		SET_COLUMN_VIEW(state, isColumnView) {
			state.columnView = isColumnView;
		},
		TOGGLE_COLUMN_VIEW(state) {
			state.columnView = !state.columnView;
			// state.showPdp = false
		},
		/*SET_HIGHLIGHT_RESULTS(state, val) {
		  state.highlightResults = val;
		},*/
		SET_LANGUAGE(state, lang) {
			state.language = lang;
		},
		SET_CURRENT_STORE(state, store) {
			state.currentStore = store;
		},
    SET_CURRENT_STORE_OBJ(state, storeObj) {
      state.currentStoreObj = storeObj;
    },
		SET_ZONES_ARRAY(state, zones) {
			state.zonesArray = zones;
		},
		SET_PDF(state, pdf) {
			state.pdf = pdf;
		},
		SET_SEARCH_INPUT_FOCUSED(state, s) {
			state.searchInputFocused = s;
			state.showHamburgerMenu = false;
			state.showSideBar = false;
			state.showPdp = false
		},
		SET_PDP_DISPLAY(state, value) {
			state.showPdp = value;
		},
		SET_CURRENT_PRODUCT(state, e) {
			state.currentProduct = e;
		},
		SET_CURRENT_VIDEO(state, url) {
			state.currentVideo = url;
		},
		SET_BLOCK_DATA(state, data) {
			state.blockData = data;
		},
		SET_CURRENT_PAGE_NUMBER(state, val) {
			state.currentPageNumber = val
		},
		SET_CURRENT_PAGE_INDEX(state, val) {
			state.currentPageIndex = val
		},
		SHOW_HAMBURGER_MENU(state, value) {
			state.showHamburgerMenu = value;
		},
		SET_X_RAY_MODE(state, value) {
			state.xRayMode = value;
		},
		SET_X_RAY_DATA(state, payload) {
			state.xRayData = {
				block: payload.block,
				page: payload.page,
				flyer: payload.flyer,
				product: payload.product || null
			}
		},
		SET_PAGE_RENDERED_DATA(state, payload) {
			state.pageRenderedData = payload;
		},
		SET_FLYER_RENDERED_DATA(state, payload) {
			state.flyerRenderedData = payload;
		},
		SET_PRODUCT_RENDERED_DATA(state, payload) {
			state.productRenderedData = payload;
		},
		SET_IMAGE_RENDERED_DATA(state, payload) {
			state.imageRenderedData = payload;
		},
		TOGGLE_SIDEBAR(state, value) {
			state.showSideBar = value;
		},
		TOGGLE_MOBILE_FILTERS(state) {
			state.showFilters = !state.showFilters;
		},
		  SET_TILED_VIEW(state, value) {
    	state.istiledView = value;

  		},
  		TOGGLE_TILED_VIEW(state) {
      	 state.istiledView = !state.istiledView;

    	},
		RESET(state) {
			state.currentPageIndex = 0;
		},

		ADD_PAGE_INJECTION(state, payload) {
			state.pageInjections.push(payload);
		},
		CLEAR_PAGE_INJECTIONS(state) {
			state.pageInjections = [];
		},
		RESET_SCROLL_CONTEXT_TOGGLE(state,val) {
		state.scrollResetKeyByToggle=val;
	},

	},
	modules: {
		categories,
		search,
		scale,
		screen,
		toast,
		inlineDrawers,
		landingPage,
		config,
		shoppingList,
		deepLinking,
		filters,
		pdp,
		header,
		drawer,
		ctUser,
		events,
		raddar,
		ctOffersUser,
        storeLocator,
		wishListStore,
		product
	},
});
